const BankValidation = () => {
  return (
    <>
      <span className="mt-2 text-sm text-gray-800 font-Medium">
        اعتبار سنجی بانکی
      </span>

      <div className="flex flex-col gap-3 p-3 rounded-lg bg-gray-50">
        <span className="text-sm text-gray-600">
          اعتبارسنجی بانکی شما بر اساس رفتار مالی شما در گذشته انجام می شود.
        </span>
      </div>
    </>
  );
};
export default BankValidation;
